import { fieldsNames } from '../constants';
import { PreparedServerCard, Card, FormValues } from '../types';
import { checkIsSavedCard } from './checkIsSavedCard';

export const getActiveCardData = (activeCard: Card, cards: PreparedServerCard[]): FormValues => {
  if (checkIsSavedCard(activeCard)) {
    const {
      cardNumber = '',
      cardHolder = '',
      year = '',
      month = '',
    } = cards.find(({ id }) => id === activeCard.id) || ({} as PreparedServerCard);

    return {
      [fieldsNames.cardNumber]: cardNumber,
      [fieldsNames.cardHolder]: cardHolder,
      [fieldsNames.year]: year,
      [fieldsNames.month]: month,
      [fieldsNames.cvv]: activeCard[fieldsNames.cvv],
    };
  }

  return activeCard;
};
